// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BronzeStage__content--lfInh {
    max-width: 400px;
    margin: 0 auto;
    width: 100%;
}

    @media screen and (min-width: 1024px) {.BronzeStage__content--lfInh {
        max-width: 640px
}

        .BronzeStage__content--lfInh.BronzeStage__finish--kwT7o {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            min-height: calc(100vh - 160px);        
        }
    }

    @media screen and (max-width: 1023px) {

    .BronzeStage__content--lfInh.BronzeStage__contentWithFlex--cWCHT {
            min-height: calc(100vh - 24px);
            display: flex;
            flex-direction: column;
            justify-content: space-between
    }
        }

.BronzeStage__wrapper--pmeBy {
    position: relative;
}

@media screen and (min-width: 1024px) {

.BronzeStage__wrapper--pmeBy {
        overflow: hidden;
        margin-bottom: 12px
}
    }

.BronzeStage__header--fkSEZ {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.BronzeStage__logo--XkN4Q {
    margin-bottom: 16px;
}

@media screen and (min-width: 1024px) {

.BronzeStage__logo--XkN4Q {
        margin-bottom: 28px
}
    }

.BronzeStage__logo--XkN4Q img {
        width: 149px;
        height: 35px;
    }

.BronzeStage__previewTitle--hb5tz {
    color: var(--tertiary-color);
    text-align: center;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    text-transform: uppercase;
    margin-bottom: 16px;
}

@media screen and (min-width: 1024px) {

.BronzeStage__previewTitle--hb5tz {
        font-size: 22px;
        line-height: 28px;
        margin-bottom: 52px
}
    }

.BronzeStage__buttonCheck--ktrSy,
.BronzeStage__buttonClose--_tayl {
    z-index: 1;
    border-radius: 50%;
    padding: 8px;
    cursor: pointer;
    border: none;
    background-color: #464D65;
    pointer-events: none;
    padding: 4px;
    --icon-size: 16px;
}

@media screen and (min-width: 1024px) {

.BronzeStage__buttonCheck--ktrSy,
.BronzeStage__buttonClose--_tayl {
        --icon-size: 24px
}
    }

.BronzeStage__buttonClose--_tayl svg {
        color: var(--warning-color);
    }

.BronzeStage__buttonCheck--ktrSy svg {
        color: var(--approved-color);
    }

.BronzeStage__counterInformation--G6kJJ {
    color: var(--dark-fourth-new-color);
    text-align: center;
    font-weight: 700;
    line-height: 20px;
    text-transform: uppercase;
    margin-bottom: 16px;
}

@media screen and (min-width: 1024px) {

.BronzeStage__counterInformation--G6kJJ {
        margin-bottom: 24px
}
    }

.BronzeStage__counterInformationLabel--Hrm2v {
    font-size: 12px;
}

@media screen and (min-width: 1024px) {

.BronzeStage__counterInformationLabel--Hrm2v {
        font-size: 16px;
        line-height: 28px
}
    }

.BronzeStage__counterInformationValue--h3iKq {
    font-size: 20px;
}

@media screen and (min-width: 1024px) {

.BronzeStage__counterInformationValue--h3iKq {
        margin-bottom: 24px;
        font-size: 28px;
        line-height: 32px
}
    }

@media screen and (max-width: 1023px) {

.BronzeStage__teamPower--qDGep {
        position: sticky;
        bottom: 0;
        left: 0;
        background: linear-gradient(0deg, #181819 68.12%, rgba(24, 24, 25, 0.00) 100%);
        padding: 16px;
        width: calc(100% + 32px);
        z-index: 20;
        margin-left: -16px
}
    }

.BronzeStage__teamPowerTitle--wh6CU {
    color: #94A5CD;
    text-align: center;
    font-size: 12px;
    font-weight: 700;
    line-height: 20px;
    text-transform: uppercase;
    margin-bottom: 8px;
}

@media screen and (min-width: 1024px) {

.BronzeStage__teamPowerTitle--wh6CU {
        font-size: 20px;
        line-height: 28px
}
    }

.BronzeStage__footer--Gq35p {
    margin-top: 28px;
}

@media screen and (min-width: 1024px) {

.BronzeStage__footer--Gq35p {
        margin-top: 68px
}
    }

.BronzeStage__footerWrapper--vKzb_ {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
}

@media screen and (max-width: 1023px) {

.BronzeStage__preview--CCKnT {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-height: calc(100vh - 48px);
        min-height: calc(var(--vh) * 100 - 48px)
}
    }

.BronzeStage__previewTextWithButton--ngslM {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.BronzeStage__previewText--NLFjB {
    color: var(--tertiary-color);
    font-size: 18px;
    font-weight: 500;
    text-transform: uppercase;
}

@media screen and (min-width: 1024px) {

.BronzeStage__previewText--NLFjB {
        font-size: 22px
}
    }

.BronzeStage__imageDecor--D_VKG {
    width: 126px;
    height: 6px;
    margin: 0 auto;
    display: block;
}

.BronzeStage__imageDecor--D_VKG.BronzeStage__top--_jNNq {
        margin-bottom: 24px;
    }

.BronzeStage__imageDecor--D_VKG.BronzeStage__bottom--JMcb9 {
        margin-top: 24px;
    }

@media screen and (max-width: 1023px) {
        .BronzeStage__imageDecor--D_VKG.BronzeStage__onlyDesktop--uouqs {
            display: none;
        }
    }

.BronzeStage__imageWinner--qPTXv {
    width: 100%;
    max-width: 348px;
    height: auto;
    aspect-ratio: 3.6 / 4.85;
    display: block;
    margin: 0 auto;
}

@media screen and (max-width: 518px) {

.BronzeStage__imageWinner--qPTXv {
        width: calc(100% + 32px)
}
    }

@media screen and (max-width: 375px) {

.BronzeStage__imageWinner--qPTXv {
        max-width: 320px
}
    }

@media screen and (min-width: 1024px) {

.BronzeStage__imageWinner--qPTXv {
        margin-bottom: 60px
}
    }

.BronzeStage__footerFinish--SHe8h {
    position: fixed;
    padding: 16px;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: 360px;
}

@media screen and (max-width: 518px) {

.BronzeStage__footerFinish--SHe8h {
        max-width: 100%
}
    }

@media screen and (min-width: 1024px) {

.BronzeStage__footerFinish--SHe8h {
        position: static;
        max-width: 312px;
        transform: none;
        padding: 0;
        margin: 0 auto
}
    }

/* modal */
.BronzeStage__overlay--vNC1J {
    background-color: rgba(0, 0, 0, 0.5);
    -webkit-backdrop-filter: blur(22px);
            backdrop-filter: blur(22px);
}

.BronzeStage__modal--FCufg {
    background-color: transparent;
    border: none;
    box-shadow: none;
    width: 100vw;
    height: 100vh;
    max-width: 100%;
    max-height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 28px;
}

.BronzeStage__modalImage--hi9N_ {
    width: 160px;
    height: 160px;
    opacity: 0;
    transition: opacity 0.15s linear;
    transition-delay: 0.1s;
}

.BronzeStage__modalImage--hi9N_.BronzeStage__withAnimation--GV5fy {
        opacity: 1;
    }

.BronzeStage__modalText--IuH4l {
    color: var(--tertiary-color);
    text-align: center;
    font-size: 18px;
    font-weight: 500;
    max-width: 312px;
    display: block;
}

@media screen and (min-width: 1024px) {

.BronzeStage__modalText--IuH4l {
        font-size: 22px;
        line-height: 28px
}
    }

.BronzeStage__modalTextUppercase--n1PvZ {
    text-transform: uppercase;
}

.BronzeStage__modalWrapper--PwFlp {
    max-width: 360px;
    display: flex;
    flex-direction: column;
    align-items: center;
    opacity: 0;
    transition: opacity 0.15s linear;
    transition-delay: 0.35s;
}

.BronzeStage__modalWrapper--PwFlp.BronzeStage__withAnimation--GV5fy {
        opacity: 1;
    }

.BronzeStage__modalFooter--iINlF {
    position: absolute;
    padding: 24px;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: 360px;
}

.BronzeStage__modalFooter--iINlF.BronzeStage__withChildren--D1tjx {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 16px;
    }

@media screen and (max-width: 518px) {

.BronzeStage__modalFooter--iINlF {
        max-width: 100%
}
    }

.BronzeStage__fullButton--B9FOR {
    width: 100%;
}

.BronzeStage__secondaryButton--YbrMV {
    border-color: transparent;
    background-color: #1E2028;
}

.BronzeStage__secondaryButton--YbrMV:hover {
        border-color: transparent;
    }

.BronzeStage__secondaryButton--YbrMV:active {
        border-color: transparent;
    }

.BronzeStage__statisticsListItem--QpFdl {
    display: grid;
    grid-template-columns: 68px auto;
    grid-gap: 8px;
    align-items: center;
}

.BronzeStage__statisticsListItemImage--VR6IX {
    width: 68px;
    height: 68px;
}

.BronzeStage__statisticsListItemDescription--p9x8A {
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Plelander/BronzeStage/BronzeStage.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,cAAc;IACd,WAAW;AAqBf;;IAnBI,uCALJ;QAMQ;AAkBR;;QAhBQ;YACI,aAAa;YACb,sBAAsB;YACtB,8BAA8B;YAC9B,+BAA+B;QACnC;IACJ;;IAGI;;IADJ;YAEQ,8BAA8B;YAC9B,aAAa;YACb,sBAAsB;YACtB;IAER;QADI;;AAIR;IACI,kBAAkB;AAMtB;;AAJI;;AAHJ;QAIQ,gBAAgB;QAChB;AAER;IADI;;AAGJ;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AAUvB;;AARI;;AAHJ;QAIQ;AAOR;IANI;;AAEA;QACI,YAAY;QACZ,YAAY;IAChB;;AAGJ;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;AAOvB;;AALI;;AATJ;QAUQ,eAAe;QACf,iBAAiB;QACjB;AAER;IADI;;AAGJ;;IAEI,UAAU;IACV,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,oBAAoB;IACpB,YAAY;IACZ,iBAAiB;AAKrB;;AAHI;;AAZJ;;QAaQ;AAER;IADI;;AAIA;QACI,2BAA2B;IAC/B;;AAIA;QACI,4BAA4B;IAChC;;AAGJ;IACI,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;AAKvB;;AAHI;;AARJ;QASQ;AAER;IADI;;AAGJ;IACI,eAAe;AAMnB;;AAJI;;AAHJ;QAIQ,eAAe;QACf;AAER;IADI;;AAGJ;IACI,eAAe;AAOnB;;AALI;;AAHJ;QAIQ,mBAAmB;QACnB,eAAe;QACf;AAER;IADI;;AAIA;;AADJ;QAEQ,gBAAgB;QAChB,SAAS;QACT,OAAO;QACP,8EAA8E;QAC9E,aAAa;QACb,wBAAwB;QACxB,WAAW;QACX;AAER;IADI;;AAGJ;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;AAMtB;;AAJI;;AATJ;QAUQ,eAAe;QACf;AAER;IADI;;AAGJ;IACI,gBAAgB;AAKpB;;AAHI;;AAHJ;QAIQ;AAER;IADI;;AAGJ;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;AACZ;;AAGI;;AADJ;QAEQ,aAAa;QACb,sBAAsB;QACtB,8BAA8B;QAC9B,8BAA8B;QAC9B;AAER;IADI;;AAGJ;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAK7B;;AAHI;;AANJ;QAOQ;AAER;IADI;;AAGJ;IACI,YAAY;IACZ,WAAW;IACX,cAAc;IACd,cAAc;AAelB;;AAbI;QACI,mBAAmB;IACvB;;AAEA;QACI,gBAAgB;IACpB;;AAEA;QACI;YACI,aAAa;QACjB;IACJ;;AAGJ;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,wBAAwB;IACxB,cAAc;IACd,cAAc;AAalB;;AAXI;;AARJ;QASQ;AAUR;IATI;;AAEA;;AAZJ;QAaQ;AAMR;IALI;;AAEA;;AAhBJ;QAiBQ;AAER;IADI;;AAGJ;IACI,eAAe;IACf,aAAa;IACb,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,gBAAgB;AAapB;;AAXI;;AATJ;QAUQ;AAUR;IATI;;AAEA;;AAbJ;QAcQ,gBAAgB;QAChB,gBAAgB;QAChB,eAAe;QACf,UAAU;QACV;AAER;IADI;;AAGJ,UAAU;AACV;IACI,oCAAoC;IACpC,mCAA2B;YAA3B,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,UAAU;IACV,gCAAgC;IAChC,sBAAsB;AAK1B;;AAHI;QACI,UAAU;IACd;;AAGJ;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAMlB;;AAJI;;AARJ;QASQ,eAAe;QACf;AAER;IADI;;AAGJ;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;IACV,gCAAgC;IAChC,uBAAuB;AAK3B;;AAHI;QACI,UAAU;IACd;;AAGJ;IACI,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,gBAAgB;AAWpB;;AATI;QACI,aAAa;QACb,8BAA8B;QAC9B,cAAc;IAClB;;AAEA;;AAfJ;QAgBQ;AAER;IADI;;AAGJ;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAS7B;;AAPI;QACI,yBAAyB;IAC7B;;AAEA;QACI,yBAAyB;IAC7B;;AAGJ;IACI,aAAa;IACb,gCAAgC;IAChC,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB","sourcesContent":[".content {\n    max-width: 400px;\n    margin: 0 auto;\n    width: 100%;\n\n    @media (--large) {\n        max-width: 640px;\n\n        &.finish {\n            display: flex;\n            flex-direction: column;\n            justify-content: space-between;\n            min-height: calc(100vh - 160px);        \n        }\n    }\n\n    &.contentWithFlex {\n        @media (--mobile) {\n            min-height: calc(100vh - 24px);\n            display: flex;\n            flex-direction: column;\n            justify-content: space-between;\n        }\n    }\n}\n\n.wrapper {\n    position: relative;\n\n    @media (--large) {\n        overflow: hidden;\n        margin-bottom: 12px;\n    }\n}\n\n.header {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.logo {\n    margin-bottom: 16px;\n\n    @media (--large) {\n        margin-bottom: 28px;\n    }\n\n    img {\n        width: 149px;\n        height: 35px;\n    }\n}\n\n.previewTitle {\n    color: var(--tertiary-color);\n    text-align: center;\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 20px;\n    text-transform: uppercase;\n    margin-bottom: 16px;\n\n    @media (--large) {\n        font-size: 22px;\n        line-height: 28px;\n        margin-bottom: 52px;\n    }\n}\n\n.buttonCheck,\n.buttonClose {\n    z-index: 1;\n    border-radius: 50%;\n    padding: 8px;\n    cursor: pointer;\n    border: none;\n    background-color: #464D65;\n    pointer-events: none;\n    padding: 4px;\n    --icon-size: 16px;\n\n    @media (--large) {\n        --icon-size: 24px;\n    }\n}\n\n.buttonClose {\n    svg {\n        color: var(--warning-color);\n    }\n}\n\n.buttonCheck {\n    svg {\n        color: var(--approved-color);\n    }\n}\n\n.counterInformation {\n    color: var(--dark-fourth-new-color);\n    text-align: center;\n    font-weight: 700;\n    line-height: 20px;\n    text-transform: uppercase;\n    margin-bottom: 16px;\n\n    @media (--large) {\n        margin-bottom: 24px;\n    }\n}\n\n.counterInformationLabel {\n    font-size: 12px;\n\n    @media (--large) {\n        font-size: 16px;\n        line-height: 28px;\n    }\n}\n\n.counterInformationValue {\n    font-size: 20px;\n\n    @media (--large) {\n        margin-bottom: 24px;\n        font-size: 28px;\n        line-height: 32px;\n    }\n}\n\n.teamPower {\n    @media (--mobile) {\n        position: sticky;\n        bottom: 0;\n        left: 0;\n        background: linear-gradient(0deg, #181819 68.12%, rgba(24, 24, 25, 0.00) 100%);\n        padding: 16px;\n        width: calc(100% + 32px);\n        z-index: 20;\n        margin-left: -16px;\n    }\n}\n\n.teamPowerTitle {\n    color: #94A5CD;\n    text-align: center;\n    font-size: 12px;\n    font-weight: 700;\n    line-height: 20px;\n    text-transform: uppercase;\n    margin-bottom: 8px;\n\n    @media (--large) {\n        font-size: 20px;\n        line-height: 28px;\n    }\n}\n\n.footer {\n    margin-top: 28px;\n\n    @media (--large) {\n        margin-top: 68px;\n    }\n}\n\n.footerWrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 4px;\n}\n\n.preview {\n    @media (--mobile) {\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n        min-height: calc(100vh - 48px);\n        min-height: calc(var(--vh) * 100 - 48px);\n    }\n}\n\n.previewTextWithButton {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n}\n\n.previewText {\n    color: var(--tertiary-color);\n    font-size: 18px;\n    font-weight: 500;\n    text-transform: uppercase;\n\n    @media (--large) {\n        font-size: 22px;\n    }\n}\n\n.imageDecor {\n    width: 126px;\n    height: 6px;\n    margin: 0 auto;\n    display: block;\n\n    &.top {\n        margin-bottom: 24px;\n    }\n\n    &.bottom {\n        margin-top: 24px;\n    }\n\n    @media (--mobile) {\n        &.onlyDesktop {\n            display: none;\n        }\n    }\n}\n\n.imageWinner {\n    width: 100%;\n    max-width: 348px;\n    height: auto;\n    aspect-ratio: 3.6 / 4.85;\n    display: block;\n    margin: 0 auto;\n\n    @media (--tiny-only) {\n        width: calc(100% + 32px);\n    }\n\n    @media screen and (max-width: 375px) {\n        max-width: 320px;\n    }\n\n    @media (--large) {\n        margin-bottom: 60px;\n    }\n}\n\n.footerFinish {\n    position: fixed;\n    padding: 16px;\n    bottom: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 100%;\n    max-width: 360px;\n\n    @media (--tiny-only) {\n        max-width: 100%;\n    }\n\n    @media (--large) {\n        position: static;\n        max-width: 312px;\n        transform: none;\n        padding: 0;\n        margin: 0 auto;\n    }\n}\n\n/* modal */\n.overlay {\n    background-color: rgba(0, 0, 0, 0.5);\n    backdrop-filter: blur(22px);\n}\n\n.modal {\n    background-color: transparent;\n    border: none;\n    box-shadow: none;\n    width: 100vw;\n    height: 100vh;\n    max-width: 100%;\n    max-height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 28px;\n}\n\n.modalImage {\n    width: 160px;\n    height: 160px;\n    opacity: 0;\n    transition: opacity 0.15s linear;\n    transition-delay: 0.1s;\n\n    &.withAnimation {\n        opacity: 1;\n    }\n}\n\n.modalText {\n    color: var(--tertiary-color);\n    text-align: center;\n    font-size: 18px;\n    font-weight: 500;\n    max-width: 312px;\n    display: block;\n\n    @media (--large) {\n        font-size: 22px;\n        line-height: 28px;\n    }\n}\n\n.modalTextUppercase {\n    text-transform: uppercase;\n}\n\n.modalWrapper {\n    max-width: 360px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    opacity: 0;\n    transition: opacity 0.15s linear;\n    transition-delay: 0.35s;\n\n    &.withAnimation {\n        opacity: 1;\n    }\n}\n\n.modalFooter {\n    position: absolute;\n    padding: 24px;\n    bottom: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 100%;\n    max-width: 360px;\n\n    &.withChildren {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n        grid-gap: 16px;\n    }\n\n    @media (--tiny-only) {\n        max-width: 100%;\n    }\n}\n\n.fullButton {\n    width: 100%;\n}\n\n.secondaryButton {\n    border-color: transparent;\n    background-color: #1E2028;\n\n    &:hover {\n        border-color: transparent;\n    }\n\n    &:active {\n        border-color: transparent;\n    }\n}\n\n.statisticsListItem {\n    display: grid;\n    grid-template-columns: 68px auto;\n    grid-gap: 8px;\n    align-items: center;\n}\n\n.statisticsListItemImage {\n    width: 68px;\n    height: 68px;\n}\n\n.statisticsListItemDescription {\n    color: #fff;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `BronzeStage__content--lfInh`,
	"finish": `BronzeStage__finish--kwT7o`,
	"contentWithFlex": `BronzeStage__contentWithFlex--cWCHT`,
	"wrapper": `BronzeStage__wrapper--pmeBy`,
	"header": `BronzeStage__header--fkSEZ`,
	"logo": `BronzeStage__logo--XkN4Q`,
	"previewTitle": `BronzeStage__previewTitle--hb5tz`,
	"buttonCheck": `BronzeStage__buttonCheck--ktrSy`,
	"buttonClose": `BronzeStage__buttonClose--_tayl`,
	"counterInformation": `BronzeStage__counterInformation--G6kJJ`,
	"counterInformationLabel": `BronzeStage__counterInformationLabel--Hrm2v`,
	"counterInformationValue": `BronzeStage__counterInformationValue--h3iKq`,
	"teamPower": `BronzeStage__teamPower--qDGep`,
	"teamPowerTitle": `BronzeStage__teamPowerTitle--wh6CU`,
	"footer": `BronzeStage__footer--Gq35p`,
	"footerWrapper": `BronzeStage__footerWrapper--vKzb_`,
	"preview": `BronzeStage__preview--CCKnT`,
	"previewTextWithButton": `BronzeStage__previewTextWithButton--ngslM`,
	"previewText": `BronzeStage__previewText--NLFjB`,
	"imageDecor": `BronzeStage__imageDecor--D_VKG`,
	"top": `BronzeStage__top--_jNNq`,
	"bottom": `BronzeStage__bottom--JMcb9`,
	"onlyDesktop": `BronzeStage__onlyDesktop--uouqs`,
	"imageWinner": `BronzeStage__imageWinner--qPTXv`,
	"footerFinish": `BronzeStage__footerFinish--SHe8h`,
	"overlay": `BronzeStage__overlay--vNC1J`,
	"modal": `BronzeStage__modal--FCufg`,
	"modalImage": `BronzeStage__modalImage--hi9N_`,
	"withAnimation": `BronzeStage__withAnimation--GV5fy`,
	"modalText": `BronzeStage__modalText--IuH4l`,
	"modalTextUppercase": `BronzeStage__modalTextUppercase--n1PvZ`,
	"modalWrapper": `BronzeStage__modalWrapper--PwFlp`,
	"modalFooter": `BronzeStage__modalFooter--iINlF`,
	"withChildren": `BronzeStage__withChildren--D1tjx`,
	"fullButton": `BronzeStage__fullButton--B9FOR`,
	"secondaryButton": `BronzeStage__secondaryButton--YbrMV`,
	"statisticsListItem": `BronzeStage__statisticsListItem--QpFdl`,
	"statisticsListItemImage": `BronzeStage__statisticsListItemImage--VR6IX`,
	"statisticsListItemDescription": `BronzeStage__statisticsListItemDescription--p9x8A`
};
export default ___CSS_LOADER_EXPORT___;
